import React from 'react';
import { Mail, Linkedin, Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CONTACT_INFO } from '../../constants/data';

export const ContactSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="contacto" className="py-24 bg-slate-900 text-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-8">
          {t('contact.title')}
        </h2>
        <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto font-light">
          {t('contact.subtitle')}
        </p>

        <div className="flex flex-col md:flex-row gap-6 justify-center">
          <a
            href="https://calendly.com/aaron-jags/mi-agenda"
            target="_blank"
            rel="noreferrer"
            className="group bg-white text-slate-900 px-8 py-6 rounded-2xl font-bold text-lg hover:bg-blue-50 transition-all flex items-center justify-center gap-4"
          >
            <div className="bg-blue-100 p-2 rounded-lg text-blue-600 group-hover:bg-blue-200 transition-colors">
              <Calendar size={24} />
            </div>
            <div className="text-left">
              <div className="text-xs text-slate-500 uppercase font-bold tracking-wider">
                {t('contact.calendly_btn')}
              </div>
              <div className="text-base">{t('contact.calendly_profile')}</div>
            </div>
          </a>

          <a
            href={`mailto:${CONTACT_INFO.email}`}
            className="group bg-slate-800 border border-slate-700 text-white px-8 py-6 rounded-2xl font-bold text-lg hover:bg-slate-700 transition-all flex items-center justify-center gap-4"
          >
            <div className="bg-slate-700 p-2 rounded-lg text-slate-400 group-hover:bg-slate-600 transition-colors">
              <Mail size={24} />
            </div>
            <div className="text-left">
              <div className="text-xs text-slate-400 uppercase font-bold tracking-wider">
                {t('contact.email_btn')}
              </div>
              <div className="text-base">{CONTACT_INFO.email}</div>
            </div>
          </a>

          <a
            href={CONTACT_INFO.linkedin}
            target="_blank"
            rel="noreferrer"
            className="group bg-slate-800 border border-slate-700 text-white px-8 py-6 rounded-2xl font-bold text-lg hover:bg-slate-700 transition-all flex items-center justify-center gap-4"
          >
            <div className="bg-slate-700 p-2 rounded-lg text-blue-400 group-hover:bg-slate-600 transition-colors">
              <Linkedin size={24} />
            </div>
            <div className="text-left">
              <div className="text-xs text-slate-400 uppercase font-bold tracking-wider">
                {t('contact.linkedin_btn')}
              </div>
              <div className="text-base">{t('contact.linkedin_profile')}</div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

